import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaCalendarAlt, FaLock, FaArrowLeft } from 'react-icons/fa';
import ActionDropdown from '../../../components/Utils/ActionDropdown';
import { canCloseMonth } from '../../../components/Auth/permissions';

const PayslipHeader = ({
    selectedMonth,
    handleMonthChange,
    selectedYear,
    handleYearChange,
    isLoading,
    filteredEmployees,
    onCloseMonth,
    dropdownActions,
    isMonthClosed,
    activeView,
    setActiveView,
    // Nouveaux props pour l'historique
    isHistoryView,
    onBackFromHistory,
    allowMonthlyView = true,
    monthInputDisabled = false,
    monthInputMin,
    monthInputMax
}) => {
    const { t } = useTranslation();
    const canClose = canCloseMonth();
    return (
        <div className="flex items-center gap-3">
            {/* Bouton retour pour l'historique */}
            {isHistoryView && (
            <button
                onClick={onBackFromHistory}
                className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors duration-200 font-medium border border-gray-300"
            >
                <FaArrowLeft size={14} />
                {t('payslipHeader.backToPayslips')}
            </button>
            )}

            {/* Condition pour vue annuelle (code existant) */}
            {!isHistoryView && activeView !== 'monthly' && allowMonthlyView && (
            <button
                onClick={() => setActiveView(v => v === 'monthly' ? 'annual' : 'monthly')}
                className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors duration-200 font-medium border border-gray-300"
            >
                <>
                    <FaArrowLeft size={14} />
                    {t('payslipHeader.monthlyView')}
                </>
            </button>
            )}

            {/* Sélection de mois pour l'historique ou vue mensuelle */}
            {(isHistoryView || activeView === 'monthly' || activeView === 'journal' || activeView === 'external_contracts' || activeView === 'variation') ? (
                <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg border border-gray-200 shadow-sm">
                    <FaCalendarAlt className="text-gray-400" size={16} />
                    <input
                        type="month"
                        value={selectedMonth}
                        onChange={handleMonthChange}
                        disabled={monthInputDisabled}
                        min={monthInputMin}
                        max={monthInputMax}
                        className="border-none outline-none text-gray-700 font-medium"
                    />
                </div>
            ) : (
                <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg border border-gray-200 shadow-sm">
                    <FaCalendarAlt className="text-gray-400" size={16} />
                    <input
                        type="number"
                        value={selectedYear}
                        onChange={handleYearChange}
                        className="border-none outline-none text-gray-700 font-medium w-24"
                        min="2020"
                        max="2099"
                    />
                </div>
            )}

            {/* Les boutons restants uniquement pour la vue mensuelle, non historique */}
            {!isHistoryView && activeView === 'monthly' && !isMonthClosed && canClose && (
                <button
                    className="flex items-center gap-2 px-4 py-2 bg-[--color-primary] hover:bg-[--color-orange] text-white rounded-lg transition-colors duration-200 font-medium"
                    onClick={onCloseMonth}
                    disabled={isLoading || filteredEmployees.length === 0}
                >
                    <FaLock size={14} />
                    {t('payslipHeader.closeMonth')}
                </button>
            )}

            {!isHistoryView && activeView === 'monthly' && isMonthClosed && (
                <span className="text-green-600 font-semibold ml-2">
                    {t('payslipHeader.monthClosed')}
                </span>
            )}

            {/* Dropdown d'actions seulement si ce n'est pas la vue historique */}
            {!isHistoryView && activeView === 'monthly' && <ActionDropdown actions={dropdownActions} />}
        </div>
    );
};

export default PayslipHeader;
